export default __webpack_public_path__ + "static/media/no-data-image.6b334ac1.svg";